document.documentElement.classList.remove('no-js');

document.addEventListener('click', (event) => {
  const toggle = event.target.closest('[data-menu-toggle]');
  if (!toggle) return;
  const menu = document.querySelector('[data-mobile-menu]');
  if (!menu) return;
  const open = menu.toggleAttribute('data-open');
  toggle.setAttribute('aria-expanded', String(open));
  document.body.classList.toggle('menu-open', open);
});

document.addEventListener('keyup', (event) => {
  if (event.key !== 'Escape') return;
  const menu = document.querySelector('[data-mobile-menu]');
  const toggle = document.querySelector('[data-menu-toggle]');
  menu?.removeAttribute('data-open');
  toggle?.setAttribute('aria-expanded', 'false');
  document.body.classList.remove('menu-open');
});

document.addEventListener('change', (event) => {
  const countrySelector = event.target.closest('[data-country-selector]');
  if (countrySelector) {
    countrySelector.form?.requestSubmit();
    return;
  }

  const select = event.target.closest('[data-variant-select]');
  if (!select) return;
  const option = select.options[select.selectedIndex];
  const form = select.closest('form');
  const button = form?.querySelector('[data-add-to-cart]');
  const currentPrice = form?.parentElement?.querySelector('[data-current-price]');
  const originalPrice = form?.parentElement?.querySelector('[data-original-price]');
  const priceContainer = form?.parentElement?.querySelector('[data-product-price]');
  const comparePrice = priceContainer?.querySelector('[data-compare-price]');
  const currentPriceLabel = priceContainer?.querySelector('[data-current-price-label]');
  const hasComparePrice = Boolean(option.dataset.originalPrice);
  if (currentPrice && option.dataset.price) currentPrice.textContent = option.dataset.price;
  if (originalPrice) originalPrice.textContent = option.dataset.originalPrice || '';
  if (comparePrice) comparePrice.hidden = !hasComparePrice;
  if (currentPriceLabel) currentPriceLabel.textContent = hasComparePrice ? priceContainer.dataset.saleLabel : priceContainer.dataset.regularLabel;
  if (button) {
    button.disabled = option.dataset.available !== 'true';
    button.textContent = option.dataset.available === 'true' ? button.dataset.addLabel : button.dataset.soldLabel;
  }
});

const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

function loadLazyVideo(video) {
  if (video.dataset.loaded === 'true' || reducedMotion.matches) return;
  video.querySelectorAll('source[data-src]').forEach((source) => {
    source.src = source.dataset.src;
    source.removeAttribute('data-src');
  });
  video.dataset.loaded = 'true';
  video.load();
  video.play().catch(() => {});
}

const lazyVideos = document.querySelectorAll('[data-lazy-video]');
if ('IntersectionObserver' in window) {
  const videoObserver = new IntersectionObserver((entries) => {
    entries.forEach((entry) => {
      if (!entry.isIntersecting) return;
      loadLazyVideo(entry.target);
      videoObserver.unobserve(entry.target);
    });
  }, { rootMargin: '300px 0px' });
  lazyVideos.forEach((video) => videoObserver.observe(video));
} else {
  lazyVideos.forEach(loadLazyVideo);
}

function syncEditorialVideoMotion() {
  document.querySelectorAll('.home-editorial video').forEach((video) => {
    if (reducedMotion.matches) {
      video.pause();
    } else {
      video.play().catch(() => {});
    }
  });
}

reducedMotion.addEventListener?.('change', syncEditorialVideoMotion);

function updateEditorialDepth() {
  if (reducedMotion.matches) return;
  const viewportCenter = window.innerHeight / 2;
  document.querySelectorAll('[data-parallax]').forEach((element) => {
    const rect = element.getBoundingClientRect();
    if (rect.bottom < -200 || rect.top > window.innerHeight + 200) return;
    const depth = Number(element.dataset.depth || 0.5);
    const distance = (rect.top + rect.height / 2 - viewportCenter) / window.innerHeight;
    element.style.setProperty('--parallax-y', `${Math.max(-1, Math.min(1, distance)) * depth * -42}px`);
  });
}

let editorialFrame;
function requestEditorialDepth() {
  if (editorialFrame) return;
  editorialFrame = window.requestAnimationFrame(() => {
    updateEditorialDepth();
    editorialFrame = null;
  });
}

window.addEventListener('scroll', requestEditorialDepth, { passive: true });
window.addEventListener('resize', requestEditorialDepth, { passive: true });
document.addEventListener('DOMContentLoaded', () => {
  updateEditorialDepth();
  syncEditorialVideoMotion();
});

document.addEventListener('pointermove', (event) => {
  if (reducedMotion.matches || !event.target.closest('[data-editorial-home]')) return;
  const card = event.target.closest('.home-editorial__image');
  if (!card) return;
  const rect = card.getBoundingClientRect();
  const x = (event.clientX - rect.left) / rect.width - 0.5;
  const y = (event.clientY - rect.top) / rect.height - 0.5;
  card.style.setProperty('--tilt-x', `${y * -3}deg`);
  card.style.setProperty('--tilt-y', `${x * 3}deg`);
});

document.addEventListener('pointerout', (event) => {
  const card = event.target.closest?.('.home-editorial__image');
  if (!card || card.contains(event.relatedTarget)) return;
  card.style.setProperty('--tilt-x', '0deg');
  card.style.setProperty('--tilt-y', '0deg');
});
